import React from 'react';
import { Button } from '@fragments';
import { IconFingerprint } from '@tabler/icons-react';
import SocialAvatar from '../../../SocialAvatar';
import './styles.scss';

// "Personalidade" in the composer toolbar (contract 2.3.0, `features.personality`): opens the
// personality picker for the active profile. Connected, it is an `ai` Button: the AI orb's
// vivid surface, with the profile's avatar (identity mark on its bottom-left edge) and
// "Personalidade ativa". Without one it is the plain glyph; while a mapping runs it pulses,
// and after a failed mapping an error dot asks to swap the Reel that failed.
// A visitor, or a Studio without the feature, has no button.
export default function PersonalityButton({ studio: s, disabled = false }) {
  const { t, myPersonality, profile } = s;
  if (!s.auth.signed || !myPersonality?.enabled) return null;
  const ready = !!myPersonality.personality && !myPersonality.running;
  const failed = !myPersonality.running && !!myPersonality.retry;
  const state = myPersonality.running ? 'mapping' : failed ? 'failed' : ready ? 'ready' : 'empty';
  const glyph = ready
    ? <SocialAvatar picture={profile?.picture} label={profile?.handle} badge={IconFingerprint} badgeSide="start" />
    : <IconFingerprint />;
  const label = ready ? 'personalityConnected' : state === 'mapping' ? 'personalityButtonMapping' : 'personality';
  return <Button className={`studio-personality-button is-${state}${ready ? ' is-ready' : ' studio-plain-control'}`} disabled={disabled || myPersonality.status === 'loading'}
    color={ready ? 'ai' : 'overlay'} variant="rounded" size="small" startIcon={glyph} tooltip={t(`personalityButtonTip_${state}`)} aria-label={t(`personalityButtonLabel_${state}`)}
    preventLoading onClick={() => myPersonality.open('composer')}>
    <span className="studio-personality-button__label">{t(label)}</span>
    {state === 'mapping' && <span className="studio-personality-button__pulse" aria-hidden="true" />}
    {state === 'failed' && <span className="studio-personality-button__alert" aria-hidden="true" />}
  </Button>;
}
